export const validateHTTPS = url => {
  try {
    return url ? new RegExp('https://').test(url.toLocaleLowerCase()) : false;
  } catch (error) {
    return false;
  }
};

export const validateHaveCookieName = name => {
  try {
    return name ? new RegExp(`${name}=`).test(document.cookie) : false;
  } catch (error) {
    return false;
  }
};

export const validateToShowDash = data => {
  try {
    if (data || data === 0) {
      return data;
    }
    return '-';
  } catch (error) {
    return '-';
  }
};

export const validateVehiclePlate = text => {
  try {
    return text === '' ? true : new RegExp(/^([0-9]|[a-zA-Z]|[ก-ฮ]|[ะ-์])+$/).test(text);
  } catch (error) {
    return false;
  }
};

export const validateMaxLength = (text, macLength) => {
  try {
    return text.length <= macLength;
  } catch (error) {
    return false;
  }
};

export const validateAlpha = (text, comma) => {
  try {
    if (comma) {
      return new RegExp(/^[ก-ฮะ-ูเ-ไ็-์a-zA-Z\s,]*$/i).test(text);
    }
    return new RegExp(/^[ก-ฮะ-ูเ-ไ็-์a-zA-Z\s]*$/i).test(text);
  } catch (error) {
    return false;
  }
};

export const validateEmail = email => {
  try {
    return new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(email);
  } catch (err) {
    return false;
  }
};

export const validateNumber = (num, comma) => {
  try {
    if (comma) {
      return new RegExp(/^[0-9,]*$/i).test(num);
    }
    return new RegExp(/^[0-9]*$/i).test(num);
  } catch (err) {
    return false;
  }
};

export const validateTelNumber = num => {
  try {
    return new RegExp(/^[0-9]{10}$/i).test(num);
  } catch (err) {
    return false;
  }
};

export const validateUsername = text => {
  try {
    return new RegExp(/^[a-zA-Z0-9@_-]*$/).test(text);
  } catch (error) {
    return false;
  }
};

export const validateMultiTelNumber = num => {
  try {
    if (num.length <= 10) {
      if (validateTelNumber(num)) {
        return num;
      }
      return false;
    } else if (num.length > 10) {
      const mobilePhones = num.split(',');
      if (mobilePhones.length > 1) {
        for (const [index, mobilePhone] of mobilePhones.entries()) {
          if (!validateTelNumber(mobilePhone)) {
            break;
          } else if (mobilePhones.length === index + 1) {
            return num;
          }
        }
      } else {
        if (validateTelNumber(num)) {
          return num;
        }
        return false;
      }
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const validateMoney = (data, hideFloat) => {
  try {
    if (data || data === 0) {
      return hideFloat ? data.toLocaleString() : data.toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 });
    }
    return '-';
  } catch (error) {
    return '-';
  }
};

export const validateIdentificationNo = id => {
  try {
    if (!id || id.length !== 13 || !/^[0-9]\d+$/.test(id)) {
      return false;
    }

    const summary = id.split('').splice(0, 12).reduce((accumulator, currentValue, currentIndex) => accumulator + (parseInt(currentValue) * (13 - currentIndex)), 0);

    if (((11 - (summary % 11)) % 10) === parseInt(id.charAt(12))) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};

export const validateTenantName = text => {
  try {
    return text === '' ? true : /^[ก-๛a-zA-Z0-9\s]*$/.test(text);
  } catch (error) {
    return false;
  }
};

export const validateMemberName = text => {
  try {
    return text === '' ? true : /^[ก-๛a-zA-Z0-9\s]*$/.test(text);
  } catch (error) {
    return false;
  }
};

export const validateTextAndNumber = text => {
  try {
    return text === '' ? true : /^[ก-๛a-zA-Z0-9\s]*$/.test(text);
  } catch (error) {
    return false;
  }
};
export const validateTextAndSpecialCharacter = text => {
  try {
    return text === '' ? true : /^[ก-๛a-zA-Z\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/.test(text);
  } catch (error) {
    return false;
  }
};
export const validateNumberAndSpecialCharacter = (num, comma) => {
  try {
    if (comma) {
      return new RegExp(/^[0-9,!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/i).test(num);
    }
    return new RegExp(/^[0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/i).test(num);
    } catch (err) {
    return false;
  }
};

export const isAndroid = () => navigator.userAgent.toLowerCase().includes('android');
